import IMG from "../../constants/image";
import React from "react";
import './style.css';


const StepRegisterSuccess = () => {
	return (
		<div className='w-[320px] h-[320px] md:w-[400px] py-[15px] px-[20px] md:px-[50px] md:py-[15px] text-xs bg-white rounded-2xl z-[1] animate-fadeIn'>
			<form className='flex flex-col justify-center items-center text-center gap-5 h-full' action="">
				<h2 className='text-sm font-bold'>Đăng ký thành công</h2>
				<img src={IMG.popupSuccess} alt="popupSuccess"/>
				<p className='text-xs text-[#9E9E9E]'>Chúc mừng bạn đăng ký thành công,
					trang web đang tự động chuyển đến trang Thông tin cửa hàng</p>
			</form>
		</div>
	);
}

export default StepRegisterSuccess;